import { render, staticRenderFns } from "./TeethBox.vue?vue&type=template&id=02c641f8&scoped=true&"
import script from "./TeethBox.vue?vue&type=script&lang=js&"
export * from "./TeethBox.vue?vue&type=script&lang=js&"
import style0 from "./TeethBox.vue?vue&type=style&index=0&id=02c641f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c641f8",
  null
  
)

export default component.exports